module.exports = __webpack_public_path__ + "img/size_2_4.31f710e9.png";